/**
 * `minimize-01` glyph (Untitled UI). Two arrows pointing inward to
 * the bottom-left and top-right corners to convey a minimize /
 * collapse action. Mirror of {@link MaximizeGlyph}. Uses
 * `currentColor` so the enclosing button controls tinting.
 */
export type MinimizeGlyphProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function MinimizeGlyph({ size = 24, className }: MinimizeGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MinimizeGlyph;
